import { render } from "./AyudaFactura.vue?vue&type=template&id=dba02dfa&scoped=true"
import script from "./AyudaFactura.vue?vue&type=script&lang=js"
export * from "./AyudaFactura.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=dba02dfa&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba02dfa"]])

export default __exports__